'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function screenMode() {
    // @ts-ignore
    var orientation = window.screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type;
    if (window.matchMedia) {
        return window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait';
    }
    else if (orientation) {
        if (orientation.indexOf('landscape') !== -1) {
            return 'landscape';
        }
        else {
            return 'portrait';
        }
    }
    else if (window.onorientationchange) {
        if (window.orientation === 0 || window.orientation === 180) { // portrait
            return 'portrait';
        }
        else if (window.orientation === 90 || window.orientation === -90) { // landscape
            return 'landscape';
        }
    }
    else {
        return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
    }
}

exports.screenMode = screenMode;
